export default __webpack_public_path__ + "static/media/project-img.cc8a32c2.webp";